const infoSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><path stroke-width="0" d="M7.22 4.51h1.56v1.5H7.22zm0 2.49h1.56v4.49H7.22z"/></svg>',
};

export { infoSubtle as default };
